import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPortSearchForm, IPortGeometry, TPortState, PORT } from './portTypes';

const initialState: TPortState = {
	searchedPorts: [],
	isPortSearchBusy: false,
	selectedPortGeometry: null,
};

const portSlice = createSlice({
	name: PORT,
	initialState,
	reducers: {
		searchPortsRequest: (state: TPortState, _action: PayloadAction<{ portName: string }>) => {
			state.isPortSearchBusy = true;
		},
		searchPortsSuccess: (state: TPortState, action: PayloadAction<{ ports: IPortSearchForm[] }>) => {
			state.searchedPorts = action.payload.ports;
			state.isPortSearchBusy = false;
		},
		searchPortsFailure: (state: TPortState, _action: PayloadAction<{ error: string }>) => {
			state.isPortSearchBusy = false;
		},
		clearSearchedPortsRequest: (state: TPortState) => {
			state.searchedPorts = [];
		},
		getPortGeometryByNameAndCountryRequest: (
			_: TPortState,
			_action: PayloadAction<{ portName: string; country: string }>,
		) => {
		},
		getPortGeometryByNameAndCountrySuccess: (
			state: TPortState,
			action: PayloadAction<{ portGeometry: IPortGeometry; portName: string; country: string }>,
		) => {
			state.selectedPortGeometry = action.payload.portGeometry;
		},
		getPortGeometryByNameAndCountryFailure: (state: TPortState) => {
			state.selectedPortGeometry = null;
		},
		clearSelectedPortGeometryRequest: (state: TPortState) => {
			state.selectedPortGeometry = null;
		},

		displayOutputByPortGeometryRequest: (_: TPortState, _action: PayloadAction<{ portGeometry: IPortGeometry }>) => {
			
		},
	},
});

export const {
	searchPortsRequest,
	searchPortsSuccess,
	searchPortsFailure,
	clearSearchedPortsRequest,
	getPortGeometryByNameAndCountryRequest,
	getPortGeometryByNameAndCountrySuccess,
	getPortGeometryByNameAndCountryFailure,
	clearSelectedPortGeometryRequest,
	displayOutputByPortGeometryRequest,
} = portSlice.actions;

export default portSlice.reducer;
